import type { ISEOProps } from "../types/core";

export const AdminPayoutsPageSEO: ISEOProps = {
  title: "Admin Payouts - Sugar Cribs",
  description:
    "Manage creator payouts and financial transactions on Sugar Cribs platform.",
};
